import { Component, inject } from '@angular/core';
import { table, CacTableComponent } from '@controladad/ng-base';
import { CouponApiService, cacTableIdCol } from '@core';
import { CouponItem } from '@models';
import { switchMap } from 'rxjs';

@Component({
  selector: 'lib-coupon',
  standalone: true,
  imports: [CacTableComponent],
  templateUrl: './coupon.component.html',
  styleUrls: ['./coupon.component.scss'],
})
export class CouponComponent {
  private readonly couponApi = inject(CouponApiService);

  table = table({
    itemsFn: this.couponApi.getAdapter(),
    view: {
      itemName: 'Coupon Code',
      title: 'Coupon Codes',
    },
    columns: {
      id: cacTableIdCol(),
      name: {
        label: 'Name',
        sortable: 'Name',
        filterable: [
          {
            type: 'contains',
            key: 'Name',
          },
        ],
      },
      code: {
        label: 'Code',
        sortable: 'Code',
        filterable: [
          {
            type: 'contains',
            key: 'Code',
          },
        ],
      },
      expirationDate: {
        label: 'Expiration Date',
        type: 'date',
        sortable: 'ExpirationDate',
        filterable: [
          { type: 'greater', label: 'From', controlType: 'date', key: 'ExpirationDateFrom' },
          { type: 'lower', label: 'To', controlType: 'date', key: 'ExpirationDateTo' },
        ],
      },
    },
    actions: [
      {
        type: 'icon',
        content: 'edit',
        action: (item: CouponItem) =>
          this.couponApi.get(item.id).pipe(
            //also pass the id to the entity
            switchMap(coupon => dialog$.coupon({ coupon: { ...coupon, id: item.id } }).afterSubmit())
          ),
      },
      {
        type: 'icon',
        content: 'trash',
        action: (item: CouponItem) =>
          dialog$.deletePrompt(false, { itemName: item.name }).action(() => this.couponApi.delete(item.id)),
      },
    ],
    events: {
      add: () => dialog$.coupon({}).afterSubmit(),
    },
  });
}
